module.exports = __webpack_public_path__ + "img/rightside_300.9bc7cf89.jpg";